/*************** */
/* Sentry Vue    */
/*************** */
import * as Sentry from '@sentry/vue';
import router from '@/router';

const { MODE: environment, VITE_SENTRY_URL: dsn } = import.meta.env;

const SentryService = {
  /**
   * Initialize Sentry except in development environment
   * @param {Vue} app
   */
  init(app) {
    Sentry.init({
      app,
      dsn,
      sendDefaultPii: true,
      environment,
      enableLogs: true,
      integrations: [Sentry.browserTracingIntegration({ router })],
      tracesSampleRate: 1.0,
      ignoreErrors: [
        // Ignore 403 errors
        /^Request failed with status code 403$/,
      ],
    });
  },
};

export default SentryService;
